import { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../common/Constant";
import { uploadAWS } from "../../common/AWSHelper";
import { AWS_IMAGE_FOLDER_ECOMCONFIG } from "../../common/Constant";
import FileInput from "../FormControls/FileInput";
import { Noimage } from "../../common/imagePath";

function DynamicSiteImage({ visibleCommonChange, searchQuery, dynamicModule }) {
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const [images, setImages] = useState({
    headerlogo: "",
    footerlogo: "",
    Favicon: "",
  });

  console.log(images, "images in DynamicSiteImage");

  const [btnLoader, setBtnLoader] = useState({});
  const token = localStorage.getItem("Token");

  const handleFileChange = async (file, key) => {
    if (!file?.name.match(/\.(jpg|jpeg|png|gif|ico)$/i)) {
      toastError("Please upload a valid image file (jpg, jpeg, png, gif, ico)");
      return;
    }

    setBtnLoader((prev) => ({ ...prev, [key]: true }));

    try {
      await uploadAWS(file, AWS_IMAGE_FOLDER_ECOMCONFIG, (url) => {
        if (url) {
          console.log(`${key} uploaded URL:`, url);

          setImages((prev) => ({
            ...prev,
            [key]: url,
          }));

          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError("Image uploaded but URL not returned.");
        }
      });
    } catch (error) {
      console.error("Upload error:", error);
      toastError("Upload failed. Please try again.");
    } finally {
      setBtnLoader((prev) => ({ ...prev, [key]: false }));
    }
  };

  const fetchImages = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=DYNAMIC_IMAGES`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const responseData = res.data.ResponseData || [];

      const initialImages = {
        headerlogo: "",
        footerlogo: "",
        Favicon: "",
      };

      responseData.forEach((item) => {
        if (initialImages.hasOwnProperty(item.AppConfigkey)) {
          initialImages[item.AppConfigkey] = item.AppConfigvalue;
        }
      });

      setImages(initialImages);
    } catch (err) {
      console.error("Error fetching images", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  const imageFields = [
    {
      key: "headerlogo",
      label: "Header Logo",
      size: "100px x 80px",
    },
    {
      key: "footerlogo",
      label: "Footer Logo",
      size: "100px x 80px",
    },
    {
      key: "Favicon",
      label: "Favicon",
      size: "10px x 10px",
    },
  ];

  const filteredFields = imageFields.filter((f) =>
    f.label.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Updating Dynamic Site Image:", images);
    const data = {
      headerlogo: images.headerlogo,
      footerlogo: images.footerlogo,
      Favicon: images.Favicon,
      from: dynamicModule,
    };
    console.log("Updating Dynamic Site Image:", data);

    setLoading(true);

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/dynamicSiteImage`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  async function getDynamicSiteImage() {
    try {
      const response = await axios.get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=DynamicSiteImage&from=${dynamicModule}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      const getApiData = response.data.ResponseData;
      if (Array.isArray(getApiData)) {
        const mappedImages = {};

        getApiData.forEach((item) => {
          const key =
            item.CommonConfigKey?.toLowerCase().replace(/\s+/g, "") || "";
          const value = item.CommonConfigValue;

          if (key.includes("favicon")) mappedImages.Favicon = value;
          if (key.includes("footerlogo") || key.includes("footer"))
            mappedImages.footerlogo = value;
          if (key.includes("headerlogo") || key.includes("header"))
            mappedImages.headerlogo = value;
        });

        setImages((prev) => ({
          ...prev,
          ...mappedImages,
        }));
      }

      console.log("6544848484848484844getApiData", getApiData);

      // setFormValues(updatedFormValues);
    } catch (error) {
      console.error("Error fetching Top Footer data:", error);
    }
  }

  useEffect(() => {
    getDynamicSiteImage();
  }, [dynamicModule]);

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title">
          <CLink onClick={() => setVisiblePopup(!visiblePopup)}>
            Site Images
          </CLink>
        </h5>
      </div>
      <CCollapse visible={visiblePopup || visibleCommonChange}>
        <div className="card-body">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="row">
              {filteredFields.map((field) => (
                <div
                  className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-3"
                  key={field.key}
                >
                  <div className="d-flex align-items-center border rounded p-2">
                    {/* Hidden FileInput - triggered by clicking image */}
                    <input
                      type="file"
                      accept="image/*,.ico"
                      id={`file-input-${field.key}`}
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(e.target.files[0], field.key)
                      }
                    />

                    {/* Clickable Image */}
                    <div
                      className="me-3"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        document
                          .getElementById(`file-input-${field.key}`)
                          .click()
                      }
                    >
                      <img
                        src={images[field.key] || Noimage}
                        alt={field.label}
                        className="img-thumbnail"
                        style={{
                          width: field.key === "Favicon" ? "70px" : "70px",
                          // width: field.key === "Favicon" ? "32px" : "70px",
                          height: field.key === "Favicon" ? "70px" : "70px",
                          // height: field.key === "Favicon" ? "32px" : "70px",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    </div>

                    {/* Texts */}
                    <div style={{ flex: 1 }}>
                      <label className="fw-bold d-block mb-1">
                        {field.label}
                      </label>
                      <small className="text-muted">
                        Recommended: {field.size}
                      </small>
                      {btnLoader[field.key] && (
                        <p className="text-info mb-0">Uploading...</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="text-center mb-5">
          <button onClick={handleSubmit} className="btn btn-secondary">
            Submit
          </button>
        </div>
      </CCollapse>
    </div>
  );
}

export default DynamicSiteImage;
